import { GetConsultationsEffects } from './get-consultations.effects';
import { GetChartDataEffects } from './get-chart-data.effects';

export const PetEffects = [GetConsultationsEffects, GetChartDataEffects];
